package de.kampfkalender.web

import de.kampfkalender.web.utils.Styles
import js.core.jso
import mui.icons.material.DarkMode
import mui.icons.material.DarkModeOutlined
import mui.icons.material.Menu
import mui.material.AppBar
import mui.material.AppBarPosition
import mui.material.IconButton
import mui.material.IconButtonColor
import mui.material.IconButtonEdge
import mui.material.SvgIcon
import mui.material.SvgIconSize
import mui.material.Toolbar
import mui.material.Typography
import mui.material.styles.TypographyVariant
import react.FC
import react.Props
import react.dom.aria.ariaLabel
import react.dom.html.ReactHTML
import react.dom.svg.ReactSVG
import react.useContext
import web.cssom.number
import web.cssom.rem

val Header = FC<Props> {
    val app = useContext(ApplicationContext)!!

    AppBar {
        position = AppBarPosition.fixed
        sx = jso {
            height = Styles.Header.Height
        }

        Toolbar {
            sx = jso {
                height = Styles.Header.Height
            }

            // Logo taken from Pixabay
            // https://pixabay.com/de/vectors/kickboxen-trete-karate-muay-thai-150330/
            //
            // <svg viewBox="0 0 185.31854 195.75539" version="1.1" id="svg891" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg"><path d="m 0.56,12.37 c 1.021,3.8396 3.5595,5.3297 6.6306,2.3302 1.561,-4.4191 4.7958,-2.2463 7.8616,-0.73895 2.8955,2.1353 4.375,6.0109 7.8048,7.7619 3.452,2.4539 6.7703,5.0235 8.3332,9.111 2.8041,5.8778 9.0455,8.9148 13.517,13.415 7.1367,6.5775 14.91,12.322 23.075,17.555 5.8542,3.5281 11.044,7.8598 15.619,12.934 2.9516,7.76 0.69319,17.455 3.2486,25.776 2.3661,11.937 4.7827,24.36 1.3993,36.355 -1.4769,9.775 -2.341,19.766 -3.0899,29.568 1.1723,2.9224 0.6157,7.767 5.0171,7.0992 3.2991,0.57626 7.8846,0.15159 5.9426,4.8061 -0.23798,3.2334 -0.46505,6.4683 -1.2612,9.6228 4.8778,4.1961 12.729,1.5834 18.37,5.8997 3.992,2.3616 11.963,1.3046 12.734,-0.78147 0.88503,-2.3954 -7.1735,-5.5876 -11.418,-7.4805 -3.2801,-2.1423 -6.5443,-4.2986 -7.8139,-8.2122 -0.84442,-4.5439 0.55008,-9.5617 0.58038,-14.291 1.1658,-8.502 3.1739,-16.895 3.2964,-25.53 2.771,-6.9406 3.2261,-14.517 1.7204,-21.806 -0.92732,-8.0719 -2.5773,-16.097 -2.1141,-24.259 4.4401,-2.9656 10.01,-0.81857 15.014,-1.2359 7.5161,-0.42145 14.918,-2.4369 22.389,-3.4887 2.4802,2.3069 5.6393,4.2314 5.4652,8.0339 2.6759,3.3344 -6.2138,5.2603 -4.0402,1.5024 2.1636,-3.1839 -2.6613,-7.6162 -2.9074,-2.2054 -0.62646,4.3508 -4.293,7.7298 -3.2421,12.34 -0.5811,3.7019 5.1194,2.8002 7.4805,4.3458 3.1826,-1.809 6.5701,-3.2407 9.0526,-5.9793 2.0717,-2.2854 3.8243,-3.8565 3.9918,-7.376 1.1729,-6.8982 6.7904,-13.138 6.9197,-19.85 0.11517,-5.9784 -2.6682,-11.96 -3.8218,-17.977 3.071,-2.1494 6.9883,-2.4239 10.224,-3.9249 3.1651,-3.3032 7.4899,-6.0304 8.1149,-10.82 0.81131,-6.2173 -2.3784,-14.582 -9.1523,-15.321 -3.5975,-0.39248 -9.3501,1.6571 -11.302,5.3286 -2.6372,2.6412 -4.4491,6.315 -7.0699,8.726 -3.4355,2.0233 -5.3556,-2.3733 -7.9513,-3.9077 -3.4565,-4.0821 -9.2913,-3.4076 -14.003,-4.9803 -8.0451,-2.0384 -16.447,-2.4447 -24.706,-2.5188 -4.4718,-0.63039 -9.3634,1.5943 -7.9365,6.7844 -0.23897,3.3655 3.8579,5.0219 5.512,7.6412 3.1998,1.6909 1.1218,6.8769 -2.1341,6.6195 -3.3877,0.76195 -6.7323,1.3054 -9.4459,-1.3514 -11.529,-6.9739 -23.438,-13.376 -33.971,-21.85 -11.029,-8.8321 -23.782,-15.047 -35.866,-22.263 -3.3636,-2.453 -7.2377,-3.3831 -11.197,-4.3202 -3.6399,-1.6205 -7.6942,-1.2935 -11.327,-2.8997 -4.1545,1.2085 -2.97,6.818 -3.4616,10.257 l -0.0818,1.5543 z" stroke="#000000" stroke-width="1.1024" id="path887" /></svg>

            SvgIcon {
                sx = jso {
                    marginRight = 1.rem
                }
                fontSize = SvgIconSize.large
                viewBox = "0 0 185.31854 195.75539"
                ReactSVG.path {
                    d =
                        "m 0.56,12.37 c 1.021,3.8396 3.5595,5.3297 6.6306,2.3302 1.561,-4.4191 4.7958,-2.2463 7.8616,-0.73895 2.8955,2.1353 4.375,6.0109 7.8048,7.7619 3.452,2.4539 6.7703,5.0235 8.3332,9.111 2.8041,5.8778 9.0455,8.9148 13.517,13.415 7.1367,6.5775 14.91,12.322 23.075,17.555 5.8542,3.5281 11.044,7.8598 15.619,12.934 2.9516,7.76 0.69319,17.455 3.2486,25.776 2.3661,11.937 4.7827,24.36 1.3993,36.355 -1.4769,9.775 -2.341,19.766 -3.0899,29.568 1.1723,2.9224 0.6157,7.767 5.0171,7.0992 3.2991,0.57626 7.8846,0.15159 5.9426,4.8061 -0.23798,3.2334 -0.46505,6.4683 -1.2612,9.6228 4.8778,4.1961 12.729,1.5834 18.37,5.8997 3.992,2.3616 11.963,1.3046 12.734,-0.78147 0.88503,-2.3954 -7.1735,-5.5876 -11.418,-7.4805 -3.2801,-2.1423 -6.5443,-4.2986 -7.8139,-8.2122 -0.84442,-4.5439 0.55008,-9.5617 0.58038,-14.291 1.1658,-8.502 3.1739,-16.895 3.2964,-25.53 2.771,-6.9406 3.2261,-14.517 1.7204,-21.806 -0.92732,-8.0719 -2.5773,-16.097 -2.1141,-24.259 4.4401,-2.9656 10.01,-0.81857 15.014,-1.2359 7.5161,-0.42145 14.918,-2.4369 22.389,-3.4887 2.4802,2.3069 5.6393,4.2314 5.4652,8.0339 2.6759,3.3344 -6.2138,5.2603 -4.0402,1.5024 2.1636,-3.1839 -2.6613,-7.6162 -2.9074,-2.2054 -0.62646,4.3508 -4.293,7.7298 -3.2421,12.34 -0.5811,3.7019 5.1194,2.8002 7.4805,4.3458 3.1826,-1.809 6.5701,-3.2407 9.0526,-5.9793 2.0717,-2.2854 3.8243,-3.8565 3.9918,-7.376 1.1729,-6.8982 6.7904,-13.138 6.9197,-19.85 0.11517,-5.9784 -2.6682,-11.96 -3.8218,-17.977 3.071,-2.1494 6.9883,-2.4239 10.224,-3.9249 3.1651,-3.3032 7.4899,-6.0304 8.1149,-10.82 0.81131,-6.2173 -2.3784,-14.582 -9.1523,-15.321 -3.5975,-0.39248 -9.3501,1.6571 -11.302,5.3286 -2.6372,2.6412 -4.4491,6.315 -7.0699,8.726 -3.4355,2.0233 -5.3556,-2.3733 -7.9513,-3.9077 -3.4565,-4.0821 -9.2913,-3.4076 -14.003,-4.9803 -8.0451,-2.0384 -16.447,-2.4447 -24.706,-2.5188 -4.4718,-0.63039 -9.3634,1.5943 -7.9365,6.7844 -0.23897,3.3655 3.8579,5.0219 5.512,7.6412 3.1998,1.6909 1.1218,6.8769 -2.1341,6.6195 -3.3877,0.76195 -6.7323,1.3054 -9.4459,-1.3514 -11.529,-6.9739 -23.438,-13.376 -33.971,-21.85 -11.029,-8.8321 -23.782,-15.047 -35.866,-22.263 -3.3636,-2.453 -7.2377,-3.3831 -11.197,-4.3202 -3.6399,-1.6205 -7.6942,-1.2935 -11.327,-2.8997 -4.1545,1.2085 -2.97,6.818 -3.4616,10.257 l -0.0818,1.5543 z"
                }
            }

            Typography {
                sx = jso {
                    flexGrow = number(1.0)
                }
                variant = TypographyVariant.h6
                noWrap = true
                component = ReactHTML.div

                +"Kampfkalender"
            }

            IconButton {
                color = IconButtonColor.inherit
                onClick = { app.setDarkMode(!app.darkMode) }
                ariaLabel = if (app.darkMode) {
                    "Zum helllichten Tag wechseln."
                } else {
                    "Zur finsteren Nacht wechseln."
                }

                if (app.darkMode) {
                    DarkMode()
                } else {
                    DarkModeOutlined()
                }
            }

            IconButton {
                ariaLabel = "Hauptmenü anzeigen"
                edge = IconButtonEdge.end
                color = IconButtonColor.inherit
                onClick = { app.setSidebarOpened(true) }

                Menu()
            }
        }
    }
}